export { default as CustomPageElementViewRenderer } from './ui/custom-page-element-view-renderer';
